import axios from 'axios';

export const createBrevoContact = async ({
  email,
  lang = 'en',
  customListId,
  product = 'wooclap',
  addToNewsletter = true,
  optionalFields,
}) => {
  const response = await axios.post(
    'https://ajq7jv99dg.execute-api.eu-west-3.amazonaws.com/production/subscribe',
    { email, lang, customListId, product, addToNewsletter, optionalFields }
  );

  return response?.status;
};

export const identifyBrevoContact = ({ email }) => {
  try {
    window.sendinblue.identify(email);
  } catch (err) {
    console.error(err);
  }
};
